module.exports = __webpack_public_path__ + "static/r-fail.c5bd6600.png";